import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./Component/CartContext";
import Header from "./Component/Header";
import Footer from "./Component/Footer";

const Main = lazy(() => import("./Component/Main"));
const Privacy = lazy(() => import("./Component/Privacy"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));
const CartPage = lazy(() => import("./Component/CartPage"));
const CheckOut = lazy(() => import("./Component/CheckOut"));
const Terms = lazy(() => import("./Component/Terms"));
const Shop = lazy(() => import("./Component/Shop"));
const Contact = lazy(() => import("./Component/Contact"));
const Returns = lazy(() => import("./Component/Returns"));
const About = lazy(() => import("./Component/About"));
const Delivery = lazy(() => import("./Component/Delivery"));
const Faqs = lazy(() => import("./Component/Faqs"));
const Cookies = lazy(() => import("./Component/Cookies"));
const PaymentStatus = lazy(() => import("./Component/PaymentStatus"));
const PolicyIndex = lazy(() => import("./Component/PolicyIndex"));
const PolicyPage = lazy(() => import("./Component/PolicyPage"));

function App() {
  return (
    <CartProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="app-shell">
          <Header />
          <Suspense
            fallback={
              <main className="page-loading" aria-live="polite">
                <span className="page-loading__mark" aria-hidden="true">
                  p
                </span>
                <span>Preparing something lovely…</span>
              </main>
            }
          >
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/" element={<Main />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/payment" element={<PaymentStatus />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/policies" element={<PolicyIndex />} />
              <Route path="/policies/:slug" element={<PolicyPage />} />
            </Routes>
          </Suspense>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
